import classNames from 'classnames';
import type { ReactNode } from 'react';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL, LabelL } from '@sorare/core/src/atoms/typography';
import { Fan } from '@sorare/core/src/components/animations/Fan';
import { css, keyframes } from '@sorare/css';

import { fadeIn } from '#src/components/missions/stories/fadeIn.ts';

const translateImgs = keyframes`
  0% {
    transform: translateY(60px);
  }
  100% {
    transform: translateY(0px);
  }
`;
const translateText = keyframes`
  0% {
    transform: translateY(150px);
  }
  100% {
    transform: translateY(0px);
  }
`;

const root = css`
  --image-size: calc(22 * var(--unit));
  gap: calc(6 * var(--unit));
`;
const imgsArea = css`
  position: relative;
  isolation: isolate;
  transform: translateY(60px);
  flex-wrap: wrap;
  animation: ${translateImgs} 0.6s var(--ease-in-out-quart) forwards;
  animation-delay: 0.5s;
`;

const textWrapper = css`
  transform: translateY(150px);
  animation: ${translateText} 0.65s var(--ease-in-out-quart) forwards;
  animation-delay: 0.55s;
`;
const titleClass = css`
  opacity: 0;
  animation: ${fadeIn} 0.65s var(--ease-in-out-quart) forwards;
  animation-delay: 0.55s;
`;
const subtitleClass = css`
  opacity: 0;
  animation: ${fadeIn} 0.65s var(--ease-in-out-quart) forwards;
  animation-delay: 0.6s;
`;

type Props = {
  featuredContent: ReactNode;
  title: ReactNode;
  subtitle: ReactNode;
};
export const TaskResultsPreClaimStoryTemplate = ({
  featuredContent,
  title,
  subtitle,
}: Props) => {
  return (
    <Vertical className={classNames(root, 'text-center')} center>
      <Vertical gap={2}>
        <Horizontal className={imgsArea} center>
          <Fan>{featuredContent}</Fan>
        </Horizontal>
      </Vertical>
      <Vertical className={textWrapper} gap={2} center>
        <BrandL className={titleClass}>{title}</BrandL>
        {!!subtitle && (
          <LabelL className={subtitleClass} color="var(--c-onBase-secondary)">
            {subtitle}
          </LabelL>
        )}
      </Vertical>
    </Vertical>
  );
};
